<template>
  <!-- show-info 클래스를 붙이면 폼 하단에 텍스트 표시함 -->
  <div class="form-input" :class="{ 'show-info': showInfo }">
    <input
      ref="input"
      :type="inputType"
      :id="inputID"
      :class="inputStyle"
      :value="inputValue"
      @input="updateValue($event.target)"
      :placeholder="placeholderText"
      :maxlength="showInfo ? charMaxLength : -1"
      :checked="checkStat"
    />
    <label :for="labelFor" v-on:click.prevent>
      <span>
        {{ labelValue }}
      </span>
    </label>
    <div v-if="showInfo" class="add-info">
      {{ characterLength }}/{{ charMaxLength }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputID: String,
    inputStyle: String,
    inputType: String,
    inputValue: String,
    labelFor: String,
    labelValue: String,
    placeholderText: String,
    checkStat: Boolean,
    showInfo: Boolean,
  },
  data() {
    return {
      characterLength: 0,
      charMaxLength: 20,
    };
  },
  methods: {
    showAlert(message) {
      const alertMessage = message;
      const alertCancel = this.$i18n.t('common.close');

      navigator.notification.alert(alertMessage, '', '', alertCancel);
    },
    updateValue(eventInput) {
      if (this.showInfo) {
        if (eventInput.value.length > this.charMaxLength) {
          this.showAlert(this.$i18n.t('error.tooLongGroupName'));
          // eslint-disable-next-line no-param-reassign
          eventInput.value = eventInput.value.substring(0, this.charMaxLength);

          this.characterLength = this.charMaxLength;
        } else {
          this.characterLength = eventInput.value.length;
        }
      }
      this.$emit('inputParent', eventInput.value);
    },
  },
};
</script>

<style lang="scss" src="../scss/form-input.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/FormInput.vue